import { createApp } from 'vue';
import TagsList from '../../00-vue/TagsList.vue'

'use strict';


(function ($, Drupal, once) {
  
  Drupal.behaviors.promutuel_blog_filters = {
    attach: function attach(context) {
      $(once('promutuelCoreExposedBlogFilters', '.js-filter-blog-wrapper', context)).each(function () {

        createApp(TagsList).mount('#tags-list');
        
        $('.js-filter-blog-btn').on('click', function() {
          $('.js-filter-blog-wrapper').toggleClass('d-none');
          $('body').toggleClass('overflow-hidden-notimportant')
        });
        
        $('.filter-blog__wrapper_close').on('click', function() {
          $('.js-filter-blog-wrapper').toggleClass('d-none');
          $('body').toggleClass('overflow-hidden-notimportant')
        });

        $('.js-filter-blog-submit').on('click', function() {
          $('body').toggleClass('overflow-hidden-notimportant')
        });

        $(window).on('resize', function () {
          if ($(window).width() > 992) {
            $('body').removeClass('overflow-hidden-notimportant');
            $('.js-filter-blog-wrapper').addClass('d-none');
          }
        });
      });

      function updateSearchIsExtended() {
        if (jQuery('.filter-blog__search-field input').val().length > 0) {
          $('.filter-blog__search').addClass('extended');
        } else {
          $('.filter-blog__search').removeClass('extended');
        }
      }
      
      $(once('promutuelCoreExposedBlogFilters', '.js-filter-blog__search', context)).each(function () {
        
        updateSearchIsExtended();
        $('.filter-blog__search-field input').on('change', updateSearchIsExtended);
        $('.filter-blog__search-field input').on('keydown', function(e) {
          if (e.key === 'Enter') {
            $('body').removeClass('overflow-hidden-notimportant')
          }
        });

        if ($("input[data-drupal-selector*='edit-reset']").length > 0) {
          $('.js-form-reset').removeClass('d-none');
        }
      });


      $(once('promutuelCoreExposedBlogFilters', '.js-filter-blog-select-products', context)).each(function () {

        updateCounter($('.js-filter-blog-select-products'));
        $('.js-filter-blog-select-products input').change(function () {
          updateCounter($('.js-filter-blog-select-products'));
        });

      });

      $(once('promutuelCoreExposedBlogFilters', '.js-filter-blog-select-mutuals', context)).each(function () {

        updateCounter($('.js-filter-blog-select-mutuals'));
        $('.js-filter-blog-select-mutuals input').change(function () {
          updateCounter($('.js-filter-blog-select-mutuals'));
        });

      });

      $(once('promutuelCoreExposedBlogFilters', '.js-filter-blog-select-subject', context)).each(function () {

        updateCounter($('.js-filter-blog-select-subject'));
        $('.js-filter-blog-select-subject input').change(function () {
          updateCounter($('.js-filter-blog-select-subject'));
        });

      });

      function inputCheck(list) {
        let counter = 0
        for (let i = 0; i < list.length; i++) {
          let temp = 0;
          if (list[i].checked) {
            temp++;
            counter += temp;
          }
        }
        return counter;
      }

      function updateCounter(select) {
        if (select.length > 0) {
          let counter = inputCheck($(select).find('input'));

          if (counter >= 1) {
            $(select).find('.blog-filter-counter').text(counter);
            $(select).find('.blog-filter-counter').removeClass('d-none');
          } else {
            $(select).find('.blog-filter-counter').addClass('d-none');
          }
        }
      }
    }
  }
})(jQuery, Drupal, once);
